import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function dateTodayOrInFutureValidator(control): { [key: string]: any } {
  if (control.value) {
    const yesterdaysDate = moment().subtract(1, 'day').toDate();
    const inputDate = new Date(control.value);
    inputDate.setHours(0, 0, 0, 0);
    if (yesterdaysDate < inputDate) {
      return null;
    }
    return { dateInPast: true };
  }
  return null;
}

/**
 * Validates if the provided value in the control is at least the date of provided maxDate
 * Time is ignored
 */
export function dateTodayOrInPastValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const today = moment().format('YYYY-MM-DD');
  const enteredDate = moment(control.value).format('YYYY-MM-DD');
  if (enteredDate > today) {
    return { dateInFuture: true };
  }
  return null;
}

export function minDateValidator(minDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const date = moment(value, 'DD.MM.YYYY', true);
    if (!date.isValid()) {
      return null;
    }
    if (date.format('YYYY-MM-DD') < minDate) {
      return { minDateValidation: true };
    }
    return null;
  };
}

export function maxDateValidator(maxDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const date = moment(value, 'DD.MM.YYYY', true);
    if (!date.isValid()) {
      return null;
    }
    if (date.format('YYYY-MM-DD') > maxDate) {
      return { maxDateValidation: true };
    }
    return null;
  };
}

export function checkOrderDates(form: UntypedFormGroup): { [key: string]: any } {
  const errors: { [key: string]: any } = {};
  let hasErros = false;
  const endDate = new Date(form.controls['endDate'].value);
  const startDate = new Date(form.controls['startDate'].value);
  const deliveryDate = new Date(form.controls['deliveryDate'].value);
  endDate.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  deliveryDate.setHours(0, 0, 0, 0);

  if (endDate < startDate) {
    errors.negativScope = true;
    hasErros = true;
  }
  if (endDate < deliveryDate) {
    errors.endBeforeDelivery = true;
    hasErros = true;
  }
  if (hasErros) {
    return errors;
  }
  return null;
}

export function validateDate(minYear: number, maxYear: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const date = moment(value, 'DD.MM.YYYY', true);
    if (!date.isValid()) {
      return { invalidDate: true };
    }
    const year = date.year();
    if (year < minYear || year > maxYear) {
      return { invalidDate: true };
    }
    return null;
  };
}
